import { kitchenOrderFilter } from '../../helper/ordersFilter'
import { addNewKitchenOrder, removeKitchenOrder, setKitchenMonitorConfigsUpdate, setKitchenOrdersTotalLength, updateKitchenOrder } from '../../redux/action/kitchenMonitor'
import { selectLastFoldedKitchenOrder } from '../../redux/selector/kitchen'
import { logger } from '../../logger/logger'


export const processKitchenMessageThunk = (message) => (dispatch, getState) => {
	switch (message?.type) {
		case 'kitchen.KITCHEN_ORDER_PLACED':
			logger.info(`Kitchen order placed: orderId=${message.data?.orderId} status=${message.data?.order?.status} companyIndex=${getState().login.companyIndex}`)
			handleKitchenMonitorAddOrder(message.data, dispatch, getState)
			break
		case 'kitchen.KITCHEN_ORDER_ITEMS_CHANGED':
		case 'kitchen.KITCHEN_ORDER_ITEM_CANCELED':
			logger.info(`Kitchen order items changes or canceled: orderId=${message.data?.orderId} status=${message.data?.order?.status} companyIndex=${getState().login.companyIndex}`)
			handleKitchenMonitorUpdateOrder(message.data, dispatch, getState)
			break
		case 'kitchen.KITCHEN_ORDER_SUB_ITEM_CANCELED':
			logger.info(`Kitchen order sub item canceled: orderId=${message.data?.orderId} status=${message.data?.order?.status} companyIndex=${getState().login.companyIndex}`)
			handleKitchenMonitorUpdateOrder(message.data, dispatch, getState)
			break
		case 'kitchen.KITCHEN_ORDER_ITEM_PREPARED':
			logger.info(`Kitchen order item prepared: orderId=${message.data?.orderId} status=${message.data?.order?.status} companyIndex=${getState().login.companyIndex}`)
			handleKitchenMonitorUpdateOrder(message.data, dispatch, getState)
			break
		case 'kitchen.KITCHEN_ORDER_DAY_COUNTER_ADDED':
			logger.info(`Kitchen order day counter added: orderId=${message.data?.orderId} status=${message.data?.order?.status} companyIndex=${getState().login.companyIndex}`)
			handleKitchenMonitorUpdateOrder(message.data, dispatch, getState)
			break
		case 'kitchen.KITCHEN_ORDER_CANCELED':
			logger.info(`Kitchen order canceled: orderId=${message.data?.orderId} status=${message.data?.order?.status} companyIndex=${getState().login.companyIndex}`)
			handleKitchenMonitorUpdateOrder(message.data, dispatch, getState)
			break
		case 'kitchen.KITCHEN_ORDER_CLOSED':
			logger.info(`Kitchen order closed: orderId=${message.data?.orderId} status=${message.data?.order?.status} companyIndex=${getState().login.companyIndex}`)
			handleKitchenMonitorDeleteOrder(message.data, dispatch, getState)
			break
		case 'kitchen.KITCHEN_ORDER_PREPARED':
			logger.info(`Kitchen order prepared: orderId=${message.data?.orderId} status=${message.data?.order?.status} companyIndex=${getState().login.companyIndex}`)
			handleKitchenMonitorDeleteOrder(message.data, dispatch, getState)
			break
		case 'kitchen.KITCHEN_ORDER_DISPLAY_STATUS_CHANGED':
			logger.info(`Kitchen order prepared: orderId=${message.data?.orderId} status=${message.data?.order?.status} companyIndex=${getState().login.companyIndex}`)
			handleKitchenMonitorUpdateOrderDisplayStatus(message.data, dispatch, getState)
			break
		case 'kitchen.KITCHEN_MONITOR_CONFIG_UPDATED':
			handleKitchenMonitorConfigUpdate(message.data, dispatch, getState)
			break
		default:
			logger.warn('Unknown kitchen message type: ', JSON.stringify(message))
			break
	}
}

const handleKitchenMonitorAddOrder = (data, dispatch, getState) => {
	const kitchenOrders = getState().kitchenMonitor.kitchenOrders
	const orderFilterTrue = kitchenOrderFilter(data?.kitchenConfigMonitorId, data.order, { date: getState().orderfilter.date })

	const existOrder = kitchenOrders.find(order => order.orderId === data.orderId)

	if (orderFilterTrue) {
		logger.info(`Kitchen monitor add order: orderId=${data?.orderId} kitchenConfigMonitorId=${data?.kitchenConfigMonitorId} companyIndex=${getState().login.companyIndex}`)
		if (!existOrder) {
			dispatch(setKitchenOrdersTotalLength(getState().kitchenMonitor.ordersTotalLength + 1))
			dispatch(addNewKitchenOrder(data.order))
		}
	}
}

const handleKitchenMonitorUpdateOrder = (data, dispatch, getState) => {
	const kitchenOrders = getState().kitchenMonitor.kitchenOrders
	const existOrder = kitchenOrders.find(order => order.orderId === data.orderId)
	const orderFilterTrue = kitchenOrderFilter(data?.kitchenConfigMonitorId, data.order, { date: getState().orderfilter.date })

	if (orderFilterTrue) {
		logger.info(`Kitchen monitor update order: orderId=${data?.orderId} kitchenConfigMonitorId=${data?.kitchenConfigMonitorId} companyIndex=${getState().login.companyIndex}`)
		if (existOrder) {
			dispatch(updateKitchenOrder(data.order))
		}
	}
}

const handleKitchenMonitorUpdateOrderDisplayStatus = (data, dispatch, getState) => {
	const kitchenOrders = getState().kitchenMonitor.kitchenOrders
	const existOrder = kitchenOrders.find(order => order?.orderId === data.orderId)
	const orderFilterTrue = kitchenOrderFilter(data?.kitchenConfigMonitorId, data.order, { date: getState().orderfilter.date })
	const shouldOpenKitchenOrder = data.order.displayStatus === 'OPENED'

	if (orderFilterTrue) {
		if (existOrder) {
			dispatch(updateKitchenOrder(data.order))
		} else {
			if (shouldOpenKitchenOrder) {
				dispatch(addNewKitchenOrder(data.order))
				const lastFoldedKitchenOrder = selectLastFoldedKitchenOrder(getState())
				if (lastFoldedKitchenOrder) {
					dispatch(removeKitchenOrder(lastFoldedKitchenOrder))
				}
			}
		}
	}
}

const handleKitchenMonitorDeleteOrder = (data, dispatch, getState) => {
	const kitchenOrders = getState().kitchenMonitor.kitchenOrders
	const existOrder = kitchenOrders.find(order => order.orderId === data.orderId)

	if (existOrder) {
		logger.info(`Kitchen monitor deleted order: orderId=${data?.orderId} kitchenConfigMonitorId=${data?.kitchenConfigMonitorId} companyIndex=${getState().login.companyIndex}`)
		dispatch(removeKitchenOrder(data.order))
		dispatch(setKitchenOrdersTotalLength(getState().kitchenMonitor.ordersTotalLength - 1))
	}
}

export const handleKitchenMonitorConfigUpdate = (data, dispatch, getState) => {
	if (window.location.pathname === '/kitchen-monitor') {
		const configs = getState().kitchenMonitor.kitchenMonitorConfigs
		const isExistConfig = !!configs.find(item => item?.id === data?.kitchenMonitorConfig?.id)
		if (isExistConfig) dispatch(setKitchenMonitorConfigsUpdate(data?.kitchenMonitorConfig))
	}
}
